import * as React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Banner from "../components/Banner";
import Socials from "../components/Socials";
import AssetItem from "../components/AssetItem"; // Stelle sicher, dass diese Komponente existiert

// Beispiel-Daten für Assets
const assets = [
  {
    title: "Dragon Blood Kunai",
    description: "HDR Kunai Weapon Model with large variety of textures",
    imageUrl: "/kunais_socialBannerBG.png",
    link: "https://assetstore.unity.com/packages/slug/310120",
  },

  // Weitere Assets hinzufügen...
];

export default function Assets() {
  return (
    <>
      <Banner />

      <Container maxWidth="md" disableGutters>
        <Box
          sx={{
            p: 4,
            backgroundColor: "background.primary",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            sx={{
              mb: 4,
              textAlign: "center",
              fontWeight: "bold",
              fontFamily: "MedievalSharp",
            }}
          >
            My Game Assets:
          </Typography>

          <Grid container spacing={4}>
            {assets.map((asset, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <AssetItem
                  title={asset.title}
                  description={asset.description}
                  imageUrl={asset.imageUrl}
                  link={asset.link}
                />
              </Grid>
            ))}
          </Grid>

          {/* Social Media Links Section */}
          <Box mt={4}>
            <Socials />
          </Box>
        </Box>
      </Container>
    </>
  );
}
